jQuery( document ).ready( function($) {

	// slick slider
	$( '.slide-banner' ).slick({
		speed: 1000,
		autoplay: true,
		autoplaySpeed: 3000,
		fade: true,
		dots: true,
		arrows: true,
		appendDots: $( '.page-slider-nav' )
	});

	// reveal the menu
	$( '.j-show-menu' ).on( 'click', function(e) {
		e.preventDefault();

		$( this ).toggleClass( 'open' );
		$( '.navigation' ).addClass( 'slidein' );
		$( 'body' ).addClass( 'noscroll' );
		$( '.page-overlay' ).addClass( 'show' );
	});

	// hide the menu
	$( '.j-hide-menu' ).on( 'click', function(e) {
		e.preventDefault();

		$( '.navigation' ).removeClass( 'slidein' );
		$( 'body' ).removeClass( 'noscroll' );
		$( '.page-overlay' ).removeClass( 'show' );
	});

	// add arrow to dropdown menu items
	$( '.menu-item-has-children' ).prepend( '<span></span>' );

	// toggle the sub menu
	$( '.menu-item-has-children' ).on( 'click', 'span', function(e) {
		$( this ).closest( 'li' ).find( '.submenu' ).toggleClass( 'shown' );
	});

	// message box
	if( getCookie( 'show_cookie_message' ) != 'no') {
		$( '#message_box' ).addClass( 'shown' );
	}

	$( '.message_box_close' ).click( function() {
		$( '#message_box' ).removeClass( 'shown' );
		setCookie( 'show_cookie_message', 'no' );
		return false;
	});

	function setCookie( cookie_name, value ) {
		document.cookie = cookie_name+ "=" + escape(value);
	}

	function getCookie( cookie_name ) {
		if ( document.cookie.length>0 ) {
			cookie_start = document.cookie.indexOf( cookie_name + "=" );

			if ( cookie_start != -1 ) {
				cookie_start = cookie_start + cookie_name.length+1;
				cookie_end = document.cookie.indexOf( ";",cookie_start );
				if ( cookie_end == -1 ) {
					cookie_end = document.cookie.length;
				}
				return unescape( document.cookie.substring( cookie_start,cookie_end ) );
			}
		}
		return "";
	}

});